module.exports = __webpack_public_path__ + "img/casesTitle.e0270a88.png";